/**
 * Returns the backend base URL.
 *
 * Strategy:
 *   1. At runtime in the browser, use `window.location.origin` so the frontend
 *      always talks to the SAME host that served the page. This makes API calls
 *      same-origin → no CORS, no build-time env coupling. Works on:
 *        - Preview:    https://ad-journal-hub.preview.emergentagent.com
 *        - Production: https://journals.newlogical.com
 *   2. Fall back to REACT_APP_BACKEND_URL only when running outside a browser
 *      (SSR, tests, or build-time tooling).
 *
 * This intentionally IGNORES a misconfigured REACT_APP_BACKEND_URL in production
 * — the env var is a build-time constant and can't be fixed without a rebuild,
 * but window.location is always right.
 */
export function getBackendBase() {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

export const BACKEND = getBackendBase();
